import { FormattedMessage } from "react-intl";

import {
  FaPaintBrush,
  FaPuzzlePiece,
  FaBlogger,
  FaQuestion,
  FaLinux,
  FaHandHoldingUsd,
  FaSearchengin,
  FaHandsHelping,
  FaUserCog,
  FaHandRock,
  FaGripfire,
  FaPenNib,
  FaRegLightbulb,
  FaPizzaSlice,
  FaUsers,
  FaRegClock,
  FaBrain,
  FaMobileAlt,
  FaTheaterMasks,
  FaUserShield,
  FaMicrophoneAlt,
  FaUniversity,
  FaChartBar,
  FaExchangeAlt,
  FaTools,
  FaUserTag,
  FaBuilding,
  FaHandshake,
  FaHandHoldingHeart,
  FaPhotoVideo,
  FaRegQuestionCircle,
  FaShapes,
} from "react-icons/fa";
import {
  BsPhone,
  BsPenFill,
  BsCameraVideoFill,
  BsMusicNoteBeamed,
  BsCodeSlash,
  BsFillQuestionCircleFill,
  BsFillPlusCircleFill,
  BsCalendarEvent,
  BsFilePost,
  BsNewspaper,
  BsFillGrid1X2Fill,
  BsBag,
  BsSearch,
  BsLaptop,
  BsFillChatDotsFill,
  BsMailbox2,
  BsEmojiSmile,
  BsFillStarFill,
  BsGoogle,
  BsFillCameraVideoFill,
  BsFillCollectionPlayFill,
  BsInfoCircle,
  BsListUl,
  BsGlobe,
  BsInfo,
  BsBriefcase,
  BsBriefcaseFill,
  BsFillBarChartFill,
  BsLayersFill,
  BsBoundingBox,
} from "react-icons/bs";
import {
  MdOutlineBusiness,
  MdWebAsset,
  MdNetworkCell,
  MdAmpStories,
  MdLocalOffer,
  MdPostAdd,
  MdOutlineFindInPage,
  MdWorkOutline,
  MdPersonSearch,
  MdUpdate,
  MdWeb,
  MdTouchApp,
  MdDesignServices,
  MdLocationPin,
  MdInsights,
  MdFeed,
  MdSettingsSuggest,
  MdPublish,
  MdApi,
} from "react-icons/md";
import {
  RiQuillPenFill,
  RiContactsBookLine,
  RiAppsFill,
  RiDeviceRecoverLine,
  RiFileSearchFill,
  RiGuideLine,
} from "react-icons/ri";
import {
  AiOutlineFire,
  AiTwotoneSetting,
  AiFillStar,
  AiFillAndroid,
  AiFillApple,
  AiFillWindows,
  AiOutlineFundProjectionScreen,
  AiOutlineMobile,
  AiFillHeart,
  AiFillCalendar,
} from "react-icons/ai";

import {
  GiSkills,
  GiMedallist,
  GiWalkingScout,
  GiLion,
  GiFlowerTwirl,
  GiVirtualMarker,
  GiCutDiamond,
  GiChart,
} from "react-icons/gi";
import { TbRefreshAlert } from "react-icons/tb";

import {
  IoGameController,
  IoDocumentSharp,
  IoGlassesSharp,
  IoHelpBuoy,
} from "react-icons/io5";

import { HiDocumentReport, HiSpeakerphone, HiTemplate } from "react-icons/hi";
import { ImBooks, ImPriceTag } from "react-icons/im";
import { GrDocumentPerformance } from "react-icons/gr";

import {
  BiUserCircle,
  BiBookContent,
  BiTrendingUp,
  BiMobile,
  BiTask,
} from "react-icons/bi";
import { IoMdAnalytics, IoMdOptions, IoMdSchool } from "react-icons/io";

export const MainData = [
  {
    link: <FormattedMessage id="aboutus" defaultMessage="About" />,
    to: "/",
  },

  {
    link: <FormattedMessage id="Services" defaultMessage="Services" />,
    to: "/",
  },

  {
    link: <FormattedMessage id="OurWork" defaultMessage="Our Work" />,
    to: "/",
  },

  {
    link: <FormattedMessage id="academy" defaultMessage="Academy" />,
    to: "/",
  },

  {
    link: <FormattedMessage id="blog" defaultMessage="Blog" />,
    to: "/Blog",
  },

  {
    link: <FormattedMessage id="careers" defaultMessage="Careers" />,
    to: "/",
  },
];
